
import { MollieTerminalService } from "@/services/mollie-terminal-service";
import { MollieTerminal } from "@/utils/mollie-terminal/mollie-terminal";
import Vue from "vue";
import { TranslateResult } from "vue-i18n";
import { ISelectItem } from "winfakt-vue-components";

export default Vue.extend({
	data(){
		return {
			availableTerminals: [] as MollieTerminal[]
		};
	},
	props: {
		value: {
			type: String
		},
		label: {
			type: [String, Object as ()=>TranslateResult]
		},
		fancy: Boolean
	},
	computed: {
		items():ISelectItem<string>[]{
			return this.availableTerminals.map(a=>{
				return {
					text: a.toString(),
					value: a.ID
				} as ISelectItem<string>;
			});
		}
	},
	methods: {
		async fetchTerminals(){
			this.availableTerminals = await MollieTerminalService.getTerminals();
		},
		onInput(value:string){
			this.$emit("input", value);
		}
	},
	mounted(){
		this.fetchTerminals();
	}
});
